<script>
  import { Link, Button, Modal } from "../../../Components";
  import { Clock } from "../../../Components/Icons";
  import Popup from "./Popup.svelte";

  export let item;

  let attachmentFilename = "";
  let attachmentPath = "//www.institutional-money.com/content/kgv/anhaenge/";
  if (item.eventAttachment.length > 0) {
    attachmentFilename = attachmentPath + item.eventAttachment[0].filename;
  }
  let bild1Online = "//www.institutional-money.com/content/kgv/bilder/" + item.referent1image;

  let showModal = false;
</script>

<div class="mb-8 grid grid-cols-1 gap-2 bg-im-gray-200 p-2 md:grid-cols-5">
  <div class="clearfix md:col-span-3">
    <h2 class="text-lg font-bold">{item.referent1name}</h2>
    <figure class="float-left mb-3 mr-3 max-w-[120px]">
      <img width="120" height="180" class="max-w-full object-cover" alt={item.referent1name} src={bild1Online} />
    </figure>
    <p>{item.eventDescription2}</p>
    {#if item.eventAttachment.length > 0}
      <Link target="_blank" rel="noreferrer" href={attachmentFilename} minor class="mt-4">Vortrag des Referenten</Link>
    {/if}
  </div>
  <div class="bg-white p-2 md:col-span-2">
    <h3 class="text-lg">Vortrag: {item.startDate || ""}</h3>
    {#if item.referent2resume}{item.referent2resume}{/if}
    <p class="flex items-center gap-1">
      <Clock class="h-4 w-4 text-theme-minor-500" />
      <span>{item.location}: {item.startTime} - {item.endTime}</span>
    </p>
    <p class="font-bold">{item.eventTitle}</p>
    <p>{item.eventDescription}</p>
    {#if item.referent1resume}
      <Button
        on:click={() => {
          showModal = true;
        }}
        class="mt-4">Mehr Info</Button
      >
    {/if}
  </div>
</div>

<Modal bind:showModal><Popup {item} /></Modal>
